module.exports = __webpack_public_path__ + "img/tokenpocket1.afb499a7.png";